import { animate, style, transition, trigger } from '@angular/animations';

// TODO: replace deprecated Angular animations with CSS animations
export const notificationAnimation = trigger('notificationAnimation', [
  transition(':enter', [style({ top: -200 }), animate('0.5s ease-out', style({ top: 10 }))]),
  transition(':leave', [style({ top: 10 }), animate('0.5s ease-in', style({ top: -200 }))]),
]);
